<template>
  <span>
    {{ data.value }}
  </span>
</template>

<script>
import BaseDisplayType from './Base.vue'

export default {
  name: 'UrlDisplayType',
  extends: BaseDisplayType,
}
</script>

<style scoped>

</style>
